package org.evoleq.compose.routing

import androidx.compose.runtime.*
import androidx.compose.runtime.snapshots.Snapshot
import kotlinx.browser.window
import org.w3c.dom.Location


/**
 * Global state holding the current path of the application
 */
internal val currentPath: MutableState<String> by lazy{ mutableStateOf(window.location.newPath()) }
fun currentPath(): String = currentPath.value
/**
 * Little helper function to render details og the location object
 */
fun Location.newPath() = "${pathname}${search}"//.ifBlank{ "/" }

/**
 * Navigate to a new location
 */
@RoutingDsl
fun navigate(to: String, title: String = "") {
    window.history.pushState(null, title, to)
    /*
    The history API unfortunately provides no callback to listen for
    [window.history.pushState], so we need to notify subscribers when pushing a new path.
     */
    Snapshot.withMutableSnapshot {
        currentPath.value = window.location.newPath()
    }
}

@RoutingDsl
fun openUrlInNewTab(url: String) {
    window.open(
        url = url,
        target = "_blank",
        features = "noopener, noreferrer"
    )
}

/**
 * Handle route changes
 */
/*
@RoutingDsl
@Composable
@Suppress("FunctionName")
fun Routing(initPath: String,routes: RoutesConfiguration.()->Unit): Routes = with(routing(routes)){
    @Composable
    fun path(): State<String> {
        LaunchedEffect(Unit) {
            window.onpopstate = {
                currentPath.value = window.location.newPath()
                Unit
            }
        }
        return derivedStateOf { currentPath.value.ifBlank { initPath } }
    }

    if(window.location.pathname.isBlank() || window.location.pathname == "/") {
        navigate(initPath)
    }
    compose(path().value)
    this
}
*/

@RoutingDsl
@Composable
@Suppress("FunctionName")
fun Routing(
    initPath: String,
    redirect: () -> String = {initPath},
    routes: RoutesConfiguration.() -> Unit): Routes =
    with(routing(routes)) {

        @Composable
        fun path(): State<String> {

            LaunchedEffect(Unit) {
                window.onpopstate = {
                    Snapshot.withMutableSnapshot {
                        currentPath.value = window.location.newPath()
                    }
                    Unit
                }
            }

            return remember {
                derivedStateOf { currentPath.value.ifBlank { initPath } }
            }
        }

        if (window.location.pathname.isBlank() || window.location.pathname == "/") {

            navigate(redirect())
        }

        compose(path().value)
        this
    }
